/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_sg_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Free online slug generator. Convert any title or text into a clean, lowercase, SEO-friendly URL slug — accents stripped, spaces and symbols replaced. Works in your browser.`)
};

const es_sg_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Generador de slug en línea gratuito. Convierte cualquier título o texto en un slug de URL limpio, en minúsculas y amigable con SEO — acentos eliminados, espacios y símbolos reemplazados. Funciona en tu navegador.`)
};

const de_sg_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kostenloser Online-Slug-Generator. Verwandeln Sie jeden Titel oder Text in einen sauberen, kleingeschriebenen, SEO-freundlichen URL-Slug — Akzente entfernt, Leerzeichen und Symbole ersetzt. Funktioniert in Ihrem Browser.`)
};

const nl_sg_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gratis online slug generator. Zet elke titel of tekst om in een schone, kleine letter, SEO-vriendelijke URL slug — accenten verwijderd, spaties en symbolen vervangen. Werkt in uw browser.`)
};

const fr_sg_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Générateur de slug URL gratuit en ligne. Convertissez n'importe quel titre ou texte en un slug URL propre, minuscule et optimisé pour le SEO — accents supprimés, espaces et symboles remplacés. Fonctionne dans votre navigateur.`)
};

const it_sg_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Generatore di slug online gratuito. Converti qualsiasi titolo o testo in uno slug URL pulito, minuscolo e SEO-friendly — accenti rimossi, spazi e simboli sostituiti. Funziona nel tuo browser.`)
};

const pt_br2_sg_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gerador de slug de URL on-line gratuito. Converta qualquer título ou texto em um slug de URL limpo, em minúscula e amigável para SEO — acentos removidos, espaços e símbolos substituídos. Funciona no seu navegador.`)
};

const pt_sg_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gerador de slugs online gratuito. Converta qualquer título ou texto num slug de URL limpo, minúsculo e otimizado para SEO — acentos removidos, espaços e símbolos substituídos. Funciona no seu navegador.`)
};

const ja_sg_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`無料のオンラインスラグジェネレータ。任意のタイトルやテキストをクリーン、小文字、SEOフレンドリーなURLスラグに変換します — アクセント記号は削除、スペースと記号は置き換えられます。ブラウザで動作します。`)
};

const zh_sg_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`免费的在线 slug 生成器。将任意标题或文本转换为简洁、小写、对 SEO 友好的 URL slug——去除重音符号，替换空格和符号。可在浏览器中运行。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const sg_meta_description = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.sg_meta_description(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("sg_meta_description", locale)
	if (locale === "en") return en_sg_meta_description(inputs)
	if (locale === "es") return es_sg_meta_description(inputs)
	if (locale === "de") return de_sg_meta_description(inputs)
	if (locale === "nl") return nl_sg_meta_description(inputs)
	if (locale === "fr") return fr_sg_meta_description(inputs)
	if (locale === "it") return it_sg_meta_description(inputs)
	if (locale === "pt-BR") return pt_br2_sg_meta_description(inputs)
	if (locale === "pt") return pt_sg_meta_description(inputs)
	if (locale === "ja") return ja_sg_meta_description(inputs)
	return zh_sg_meta_description(inputs)
};